export class Mapping {
  public static items_ooc = [
    {
      "name": "SBR 2.0 OOC",
      "usecases": [
        {
          "text": "Ship Method -  Country to Country",
          "value": "SBR 2.0 OOC;Ship Method -  Country to Country",
          "mapping": {
            "businessUnit": "OOC_STANDARD",
            "componentKeyPlaceholder": "CARRIER_NAME:SHIP_METHOD",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "FROM_COUNTRY_CODE"
              },
              {
                "order": 2,
                "name": "TO_COUNTRY_CODE"
              }
            ]
          }
        },
        {
          "text": "Ship Method - Country to Zip",
          "value": "SBR 2.0 OOC;Ship Method - Country to Zip",
          "mapping": {
            "businessUnit": "OOC_STANDARD",
            "componentKeyPlaceholder": "CARRIER_NAME:SHIP_METHOD",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "TO_COUNTRY_CODE"
              },
              {
                "order": 2,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        },
        {
          "text": "Ship Method - Zip to Zip",
          "value": "SBR 2.0 OOC;Ship Method - Zip to Zip",
          "mapping": {
            "businessUnit": "OOC_STANDARD",
            "componentKeyPlaceholder": "CARRIER_NAME:SHIP_METHOD",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 2,
                "name": "TO_COUNTRY_CODE"
              },
              {
                "order": 3,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
    {
      "name": "SBR 1.0 OOC",
      "usecases": [
        {
          "text": "Country - Country to Zip",
          "value": "SBR 1.0 OOC;Country - Country to Zip",
          "mapping": {
            "businessUnit": "OOC_SBR1",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "TO_COUNTRY_CODE"
              },
              {
                "order": 2,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
  ];
  public static items_domestic = [
    {
      "name": "SBR 2.0 Domestic",
      "usecases": [
        {
          "text": "Ship Method - Zip to Zip",
          "value": "SBR 2.0 Domestic;Ship Method - Zip to Zip",
          "mapping": {
            "businessUnit": "STANDARD",
            "componentKeyPlaceholder": "CARRIER_NAME:SHIP_METHOD",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 2,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
    {
      "name": "SBR 1.0 Domestic",
      "usecases": [
        {
          "text": "Country - Zip to Zip",
          "value": "SBR 1.0 Domestic;Country - Zip to Zip",
          "mapping": {
            "businessUnit": "SBR1",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 2,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
    {
      "name": "MFN_INDIA",
      "usecases": [
        {
          "text": "Seller - Zip to Zip",
          "value": "MFN_INDIA;Seller - Zip to Zip",
          "mapping": {
            "businessUnit": "MFN_INDIA",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER:SHIP_OPTION",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "MERCHANT_ID"
              },
              {
                "order": 2,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 3,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
    {
      "name": "DOM_STT",
      "usecases": [
        {
          "text": "Seller - Zip to Zip",
          "value": "DOM_STT;Seller - Zip to Zip",
          "mapping": {
            "businessUnit": "DOM_STT",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER:SHIP_OPTION",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "MERCHANT_ID"
              },
              {
                "order": 2,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 3,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
    {
      "name": "OOC_STT",
      "usecases": [
        {
          "text": "Seller - Zip to Zip",
          "value": "OOC_STT;Seller - Zip to Zip",
          "mapping": {
            "businessUnit": "OOC_STT",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER:SHIP_OPTION",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "MERCHANT_ID"
              },
              {
                "order": 2,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 3,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    }
  ];
  public static items_transit_time_overrides = [
    {
      "name": "MFN_INDIA",
      "usecases": [
        {
          "text": "Seller - Zip to Zip",
          "value": "MFN_INDIA;Seller - Zip to Zip",
          "mapping": {
            "businessUnit": "MFN_INDIA",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER:SHIP_OPTION",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "MERCHANT_ID"
              },
              {
                "order": 2,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 3,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
    {
      "name": "DOM_STT",
      "usecases": [
        {
          "text": "Seller - Zip to Zip",
          "value": "DOM_STT;Seller - Zip to Zip",
          "mapping": {
            "businessUnit": "DOM_STT",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER:SHIP_OPTION",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "MERCHANT_ID"
              },
              {
                "order": 2,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 3,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    },
    {
      "name": "OOC_STT",
      "usecases": [
        {
          "text": "Seller - Zip to Zip",
          "value": "OOC_STT;Seller - Zip to Zip",
          "mapping": {
            "businessUnit": "OOC_STT",
            "componentKeyPlaceholder": "VIRTUAL_CARRIER:SHIP_OPTION",
            "lookUpKeys": [
              {
                "order": 1,
                "name": "MERCHANT_ID"
              },
              {
                "order": 2,
                "name": "FROM_ZIP_CODE"
              },
              {
                "order": 3,
                "name": "TO_ZIP_CODE"
              }
            ]
          }
        }
      ]
    }
  ];
}
